module.exports = __webpack_public_path__ + "static/media/home.c983cfb7.svg";